export const diaryEntryTranslations = {
  lv: {
    title: 'Pievienot ierakstu',
    editTitle: 'Labot ierakstu',
    planItem: 'Plāna punkts',
    planItemPlaceholder: 'Izvēlies plāna punktu',
    planItemHelp: 'Saraksts nāk no prakses programmas. Iekavās — cik stundu punktā vēl atlicis.',
    untitled: 'Dienasgrāmatas ieraksts',
    date: 'Datums',
    availableDates: 'Pieejamas {{start}} – {{end}}.',
    start: 'No',
    end: 'Līdz',
    break: 'Pārtraukums',
    minutes: '{{count}} min',
    place: 'Prakses vieta',
    placePlaceholder: 'Izvēlies prakses vietu',
    placeHelp: 'Kur darbs tika veikts — to redzēs šī prakses vieta.',
    grader: 'Kurš prakses vadītājs to redzēs',
    graderPlaceholder: 'Izvēlies prakses vadītāju',
    workplace: 'Darba vieta',
    comment: 'Ko šodien darīji',
    commentPlaceholder: 'Šodien praksē es…',
    commentHelp:
      'Raksti savos vārdos un konkrēti — to lasa gan prakses vieta, gan izglītības iestāde.',
    actualTime: 'Faktiskais laiks',
    academicHours: 'Akadēmiskās stundas (1 = {{length}} min)',
    weekTotal: 'Šonedēļ kopā',
    planRemaining: 'Atliks plāna punktā',
    calculating: 'Aprēķina prakses stundas…',
    loading: 'Ielādē ieraksta formu',
    submit: 'Iesniegt',
    save: 'Saglabāt',
    created: 'Ieraksts pievienots',
    saved: 'Ieraksts saglabāts',
    loadError: 'Neizdevās ielādēt ieraksta formu',
    loadErrorHelp: 'Pārbaudi savienojumu un mēģini vēlreiz.',
    closed: 'Šai praksei vairs nevar pievienot jaunus dienasgrāmatas ierakstus.',
    simpleInputUnavailable:
      'Šī prakse izmanto stundu ievades režīmu, ko pašreizējā V4 versija vēl neatbalsta. Ierakstu nevar iesniegt.',
    validation: {
      required: 'Šis lauks ir obligāts',
      invalid: 'Ievadi derīgu vērtību',
    },
  },
  en: {
    title: 'Add Diary Entry',
    editTitle: 'Edit Diary Entry',
    planItem: 'Plan item',
    planItemPlaceholder: 'Choose a plan item',
    planItemHelp:
      'The list comes from the internship program. Parentheses show the hours left on an item.',
    untitled: 'Diary Entry',
    date: 'Date',
    availableDates: 'Available {{start}} – {{end}}.',
    start: 'From',
    end: 'To',
    break: 'Break',
    minutes: '{{count}} min',
    place: 'Internship place',
    placePlaceholder: 'Choose an internship place',
    placeHelp: 'Where the work was done — this internship place will be able to see it.',
    grader: 'Supervisor who will see this',
    graderPlaceholder: 'Choose a supervisor',
    workplace: 'Workplace',
    comment: 'What I did today',
    commentPlaceholder: 'Today during my internship I…',
    commentHelp:
      'Write in your own words and be specific — both the internship place and educational institution can read it.',
    actualTime: 'Actual time',
    academicHours: 'Academic hours (1 = {{length}} min)',
    weekTotal: 'Total this week',
    planRemaining: 'Left on plan item',
    calculating: 'Calculating internship hours…',
    loading: 'Loading Diary Entry form',
    submit: 'Submit',
    save: 'Save',
    created: 'Diary Entry added',
    saved: 'Diary Entry saved',
    loadError: 'Could not load the Diary Entry form',
    loadErrorHelp: 'Check your connection and try again.',
    closed: 'New Diary Entries can no longer be added to this internship.',
    simpleInputUnavailable:
      'This internship uses the hour-count entry mode, which the current V4 version does not yet support. The entry cannot be submitted.',
    validation: {
      required: 'This field is required',
      invalid: 'Enter a valid value',
    },
  },
} as const
